﻿export interface IDomainEvent {
    name: string;   // this is used because there is no way to obtain the name of the class at runtime.
    type: EventType;
}

export enum EventType {
    Click,
    Submit,
    Focus,
    PageView,
    Ajax,
    Domain,
    Search
}

export interface IGoogleEvent extends IDomainEvent {
    category: string;
    label: string;
}

export function isGoogleEvent(object: any): object is IGoogleEvent {
    return 'category' in object && 'label' in object;
}
